import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames';
import {isAdmin, isManager} from "./utils/Utils";
import {AppContext} from "./HomePage";
import {CampaignContext} from "./App";
import {isMarketplaceOperatorCampaign} from "./components/Campaign/marketplaceOperatorSettings";

const AppSubmenu = (props) => {

    const [activeIndex, setActiveIndex] = useState(null)

    const onMenuItemClick = (event, item, index) => {
        //avoid processing disabled items
        if (item.disabled) {
            event.preventDefault();
            return true;
        }

        //execute command
        if (item.command) {
            item.command({ originalEvent: event, item: item });
        }

        if (index === activeIndex)
            setActiveIndex(null);
        else
            setActiveIndex(index);

        if (props.onMenuItemClick) {
            props.onMenuItemClick({
                originalEvent: event,
                item: item
            });
        }
    }

    const renderLinkContent = (item) => {
        let submenuIcon = item.items && <i className="pi pi-fw pi-angle-down menuitem-toggle-icon"></i>;
        let badge = item.badge && <span className="menuitem-badge">{item.badge}</span>;

        return (
            <React.Fragment>
                <i className={item.icon}></i>
                <span>{item.label}</span>
                {submenuIcon}
                {badge}
            </React.Fragment>
        );
    }

    const renderLink = (item, i) => {
        let content = renderLinkContent(item);

        if (item.to) {
            return (
                <NavLink activeClassName="active-route" to={item.to} onClick={(e) => onMenuItemClick(e, item, i)} exact target={item.target}>
                    {content}
                </NavLink>
            )
        }
        else {
            return (
                <a href={item.url} onClick={(e) => onMenuItemClick(e, item, i)} target={item.target}>
                    {content}
                </a>
            );
        }
    }

    let items = props.items && props.items.map((item, i) => {
        let active = activeIndex === i;
        let styleClass = classNames(item.badgeStyleClass, { 'active-menuitem': active && !item.to });

        return (
            <li className={styleClass} key={i}>
                {item.items && props.root === true && <div className='arrow'></div>}
                {renderLink(item, i)}
                <CSSTransition classNames="p-toggleable-content" timeout={{ enter: 1000, exit: 450 }} in={active} unmountOnExit>
                    <AppSubmenu items={item.items} onMenuItemClick={props.onMenuItemClick} />
                </CSSTransition>
            </li>
        );
    });

    return items ? <ul className={props.className}>{items}</ul> : null;
}

const AppMenu = (props) => {

    const {t} = React.useContext(AppContext);
    const {campaigns} = React.useContext(CampaignContext);

    const createMenu = () => {

        let menu = [];

        menu.push({label: t('menu_item.dashboard'), icon: 'pi pi-fw pi-eye', command: () => {window.location = '#/'}});
        menu.push({label: t('menu_item.campaigns'), icon: 'pi pi-fw pi-tags', command: () => {window.location = '#/campaign'}});
        // Onboarding is reached from the Campaigns page (Setup button per row),
        // for both admins and end users — not from the menu.
        menu.push({label: t('menu_item.products'), icon: 'pi pi-fw pi-list', command: () => {window.location = '#/product'}});
        (campaigns || []).some(isMarketplaceOperatorCampaign) && menu.push({label: t('menu_item.sellers'), icon: 'pi pi-fw pi-users', command: () => {window.location = '#/sellers'}});
        menu.push({label: t('menu_item.repricing_rules'), icon: 'pi pi-fw pi-sliders-h', command: () => {window.location = '#/repricing_rules'}});
        menu.push({label: t('menu_item.reports'), icon: 'pi pi-fw pi-chart-bar', command: () => {window.location = '#/report'}});
        menu.push({label: t('menu_item.whats_new'), icon: 'pi pi-fw pi-bell', command: () => {window.location = '#/announcements'}});
        // Admins reach Impersonation from the Management hub; non-admin managers keep a standalone menu item.
        (!isAdmin() && isManager()) && menu.push({label: t('menu_item.impersonation'), icon: 'pi pi-fw pi-users', command: () => {window.location = '#/impersonation'}});
        isAdmin() && menu.push({label: t('menu_item.management'), icon: 'pi pi-fw pi-key', command: () => {window.location = '#/management'}});
        // Campaign Quality is accessible only via the Management hub (managementCatalog.js).
        // this.menu.push({
        //     label: 'Menu Modes', icon: 'pi pi-fw pi-cog',
        //     items: [
        //         {label: 'Static Menu', icon: 'pi pi-fw pi-bars',  command: () => this.setState({layoutMode: 'static'}) },
        //         {label: 'Overlay Menu', icon: 'pi pi-fw pi-bars',  command: () => this.setState({layoutMode: 'overlay'}) }
        //     ]
        // });
        // this.menu.push({
        //     label: 'Menu Colors', icon: 'pi pi-fw pi-align-left',
        //     items: [
        //         {label: 'Dark', icon: 'pi pi-fw pi-bars',  command: () => this.setState({layoutColorMode: 'dark'}) },
        //         {label: 'Light', icon: 'pi pi-fw pi-bars',  command: () => this.setState({layoutColorMode: 'light'}) }
        //     ]
        // });

        return menu;
    }

    return (
        <div className="layout-menu-container">
            <AppSubmenu items={createMenu()} className="layout-menu" onMenuItemClick={props.onMenuItemClick} root={true} />
        </div>
    );
};
export default AppMenu;
